import type { InferredEntity } from '@sites/entity-migrator';
import { createVersionedEntityWithDefaults } from '@sites/entity-migrator';

import { lineDefaultV0Schema } from './v0';
import { lineLegacyShapeSchema } from '../legacy/shape';
import { migrateLegacyLineToV0 } from '../legacy/migration';

export const DefaultLineEntitySchema = createVersionedEntityWithDefaults({
    versionMap: {
        0: { schema: lineDefaultV0Schema },
    },
    latestVersion: 0,
    legacy: [{ name: 'web', schema: lineLegacyShapeSchema, up: migrateLegacyLineToV0 }],
});

export type DefaultLine = InferredEntity<typeof DefaultLineEntitySchema>;
